import { render, staticRenderFns } from "./strat.vue?vue&type=template&id=6937f76a&scoped=true"
import script from "./strat.vue?vue&type=script&lang=js"
export * from "./strat.vue?vue&type=script&lang=js"
import style0 from "./strat.vue?vue&type=style&index=0&id=6937f76a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6937f76a",
  null
  
)

export default component.exports